import { IonButton, IonButtons, IonContent, IonIcon, IonLabel, IonPage } from "@ionic/react";
import { useTranslation, Trans } from "react-i18next";
import { useTheme } from "react-jss";
import { AboutSecurityContainerStyle } from "./containerStyle.jss";
import Header from "../../../components/header/header";
import { arrowBackOutline } from "ionicons/icons";
import { useHistory } from "react-router";

interface IGlosaryItem {
    title: string;
    section: string[];
}
export const AboutSecurityContainer = () => {
    const { t } = useTranslation("common");
    const theme = useTheme();
    const style = AboutSecurityContainerStyle({ theme });
    const glosary: IGlosaryItem[] = [
        {
            title: t("PAGE.ABOUT_SECURITY.OUTRAGES.TITLE"),
            section: [
                "PAGE.ABOUT_SECURITY.OUTRAGES.SECTION_1",
                "PAGE.ABOUT_SECURITY.OUTRAGES.SECTION_2",
                "PAGE.ABOUT_SECURITY.OUTRAGES.SECTION_3",
                "PAGE.ABOUT_SECURITY.OUTRAGES.SECTION_4",
                "PAGE.ABOUT_SECURITY.OUTRAGES.SECTION_5",
                "PAGE.ABOUT_SECURITY.OUTRAGES.SECTION_6",
            ],
        },
        {
            title: t("PAGE.ABOUT_SECURITY.ENTRAPMENTS.TITLE"),
            section: [
                "PAGE.ABOUT_SECURITY.ENTRAPMENTS.SECTION_1",
                "PAGE.ABOUT_SECURITY.ENTRAPMENTS.SECTION_2",
                "PAGE.ABOUT_SECURITY.ENTRAPMENTS.SECTION_3",
                "PAGE.ABOUT_SECURITY.ENTRAPMENTS.SECTION_4",
            ],
        },
        {
            title: t("PAGE.ABOUT_SECURITY.FALLS.TITLE"),
            section: ["PAGE.ABOUT_SECURITY.FALLS.SECTION_1", "PAGE.ABOUT_SECURITY.FALLS.SECTION_2"],
        },
        {
            title: t("PAGE.ABOUT_SECURITY.FIRES.TITLE"),
            section: ["PAGE.ABOUT_SECURITY.FIRES.SECTION_1"],
        },
        {
            title: t("PAGE.ABOUT_SECURITY.VARIOUS_RISKS.TITLE"),
            section: ["PAGE.ABOUT_SECURITY.VARIOUS_RISKS.SECTION_1"],
        },
    ];
    const history = useHistory();
    return (
        <IonPage>
            <Header
                element={
                    <IonButtons slot="start">
                        <IonButton
                            routerDirection="back"
                            onClick={() => history.goBack()}
                        >
                            <IonIcon
                                slot="icon-only"
                                icon={arrowBackOutline}
                                size={"large"}
                                className={style.icon}
                            />
                        </IonButton>
                    </IonButtons>
                }
                title={t("GLOBAL.GLOSSARY")}
                showLogout={false}
            />
            <IonContent className="ion-padding">
                <div className={style.container}>
                    <IonLabel className={style.sectionTitle}>{t("GLOBAL.GLOSSARY")}</IonLabel>

                    <ul className={style.listType}>
                        {glosary.map((item, index) => {
                            return <li className={style.listRow}>{item.title}</li>;
                        })}
                    </ul>

                    {glosary.map((item, index) => {
                        return (
                            <>
                                <IonLabel className={style.sectionTitle}>{item.title}</IonLabel>
                                <ol className={style.listDescription}>
                                    {item.section.map((item, index) => {
                                        return (
                                            <li className={style.listRow}>
                                                <span className={style.listText}>
                                                    <Trans i18nKey={item} />
                                                </span>
                                            </li>
                                        );
                                    })}
                                </ol>
                            </>
                        );
                    })}
                </div>
            </IonContent>
        </IonPage>
    );
};
